import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { Note } from '../../../models/note';

import { NotesService } from './notes.service';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';

import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';

@Component({
    selector: 'app-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.css'],
    animations: [
        trigger('slideInOut', [
            state('*', style({ 'overflow-y': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(200, style({ height: 0 })),
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(200, style({ height: '*' })),
            ]),
        ]),
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(200, style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate(200, style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class NotesComponent {
  notes: Note[];
  notes_count = 0;
  newNoteText: string;
  expanded = false;
  noteToReply: Note = null;
  sendButtonEnabled = true;
  inputEnabled = true;
  @Input() companyId: number;
  noteType: string;
  subsArr$: Subscription[] = [];
  tempUsersImg = {};

  @Input()
  set notesType(type: string) {
    this.noteType = type;
    this.getNotes();
  }

  constructor(private _notesService: NotesService,
              private _alertService: AlertService,
              private _userService: UserService,
              private _sanitizer: DomSanitizer,
  ) {
  }

  setSelectedNote = (note: Note) => {
    this.noteToReply = note;
  }

  toggleNotesContent(): void {
    this.expanded = !this.expanded;
  }

  postNote(): void {
    if (!this.newNoteText) {
      return;
    }
    this.blockInput();
    const parentNoteId = this.noteToReply ? this.noteToReply.id : null;
    this.subsArr$.push(this._notesService.postNote(this.companyId, this.noteType, this.newNoteText, parentNoteId)
      .subscribe(
        (data: Note) => {
          data.parent = this.noteToReply;
          this.insertNewNote(data);
          this.noteToReply = null;
          this.newNoteText = '';
          this._alertService.success('Note sent successfully');
        },
        error => {
        },
        () => {
          this.unblockInput();
        },
      ),
    );
  }

  insertNewNote(note: Note) {
    this.notes_count++;
    if (!this.noteToReply) {
      this.notes.push(note);
      return;
    }

    const parentNotes: Note[] = this.notes.filter((element) => {
      return element.id === this.noteToReply.id
    });
    if (parentNotes && parentNotes.length > 0) {
      parentNotes[0].children.push(note);
      return;
    }

    this.notes.forEach(element => {
      const childNotes: Note[] = element.children.filter((item) => {
        return item.id === this.noteToReply.id
      });
      if (childNotes && childNotes.length > 0) {
        element.children.push(note);
        return;
      }
    })
  };

  blockInput() {
    this.sendButtonEnabled = false;
    this.inputEnabled = false;
  }

  unblockInput() {
    this.sendButtonEnabled = true;
    this.inputEnabled = true;
  }

  private getNotes() {
    this.subsArr$.push(this._notesService.getNotes(this.companyId, this.noteType)
      .subscribe(notes => {
        this.notes = notes;
        this.notes_count = this.notes.reduce((prev, current) => {
          prev++;
          prev += current.children ? current.children.length : 0;
          return prev;
        }, 0);
      }),
    );
  }
}
